import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading03, typeHeading04, typeBody02, typeLabel01, typeBody02_bold } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01, BLUE_01, BLACK_01 } from '../../theme/colors'

import { StyledButtons } from '../../theme/components'

import { button } from '../../theme/core';

export const Container = styled.section`
	${grid}
`

export const Location = styled.div`
	${row({medium:true})}
	padding-bottom: ${spacer(2)};

	&:last-child{
		padding-bottom: 0;
	}
`

export const Summary = styled.div`
	${props => column({medium:{span:6},large:{span:4},xlarge:{span:6}},{direction:props.theme.direction})}
	margin-bottom: ${spacer(1)};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	${mediaQuery[SIZE.medium]}{
		margin-bottom: 0;
	}
`

export const Contacts = styled.div`
	${props => column({medium:{span:6},large:{span:8},xlarge:{span:6}},{direction:props.theme.direction})}
`

export const ContactsInner = styled.div`
	${row({large:true})}
	margin-bottom: ${unit(-3)};

	${mediaQuery[SIZE.medium]}{
		margin-bottom: ${spacer(-1.5)};
	}
`

export const Contact = styled.div`
	${props => column({large:{span:4,total:8},xlarge:{span:3,total:6}},{direction:props.theme.direction})}
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: ${unit(3)};

	${mediaQuery[SIZE.medium]}{
		margin-bottom: ${spacer(1.5)};
	}
`

export const Name = styled.h2`
	${typeHeading02}
	margin-bottom: ${unit(2)};

	${mediaQuery[SIZE.medium]}{
		margin-bottom: ${unit(3)};
	}

	&:last-child{
		margin-bottom: 0;
	}
`

export const Address = styled.div`
	${typeBody02}
	margin-bottom: ${unit(2)};

	${mediaQuery[SIZE.medium]}{
		margin-bottom: ${unit(3)};
	}

	&:last-child{
		margin-bottom: 0;
	}
`

export const Communication = styled.a`
	${typeLabel01}
	display: block;
	color: ${BLACK_01};
	text-decoration: none;
	padding-bottom: ${unit(1)};
	position: relative;
	margin-bottom: ${unit(2)};

	&:last-child{
		margin-bottom: 0;
	}

	&:after{
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 2px;
		background-color: ${BLUE_01};
		transition: background-color 0.3s;
	}

	&:hover{
		&:after{
			background-color: ${BLACK_01};
		}
	}
`

export const ContactRole = styled.h3`
	${typeBody02_bold}
`

export const ContactName = styled.p`
	${typeBody02}
	margin-bottom: ${unit(2)};

	${mediaQuery[SIZE.medium]}{
		margin-bottom: ${unit(3)};
	}

	&:last-child{
		margin-bottom: 0;
	}
`

export const ContactCommunication = styled.a`
	${typeLabel01}
	display: block;
	color: ${BLACK_01};
	text-decoration: none;
	padding-bottom: ${unit(1)};
	position: relative;
	margin-bottom: ${unit(2)};

	&:last-child{
		margin-bottom: 0;
	}

	&:after{
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 2px;
		background-color: ${BLUE_01};
		transition: background-color 0.3s;
	}

	&:hover{
		&:after{
			background-color: ${BLACK_01};
		}
	}
`